export const API_USER_REPORT_REQUEST = 'API_USER_REPORT_REQUEST';
export const API_USER_REPORT_SUCCESS = 'API_USER_REPORT_SUCCESS';
export const API_USER_REPORT_FAILURE = 'API_USER_REPORT_FAILURE';

export const userReportRequest = () => ({
  type: API_USER_REPORT_REQUEST,
});

export const userReportSuccess = payload => ({
  type: API_USER_REPORT_SUCCESS,
  payload,
});

export const userReportFailure = payload => ({
  type: API_USER_REPORT_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  report: null,
};

export function userReportReducer(state = initialState, action) {
  switch (action.type) {
    case API_USER_REPORT_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_USER_REPORT_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        report: action.payload,
      };
    case API_USER_REPORT_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/userReport.js